import { MouseEvent } from "react";
import { Box, TextField } from "@mui/material";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { useStyles } from "../../hooks/useActionPlansTableColumns.styles";
import { useActionPlanNameCell } from "./useActionPlanNameCell";
import { useTranslation } from "react-i18next";

interface IActionPlanNameCellProps {
    row: IActionPlan;
}

const ActionPlanNameCell = ({ row }: IActionPlanNameCellProps) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { isEditing, name, handleNameChange, maxLength, currentLength } = useActionPlanNameCell(row);

    if (isEditing) {
        return (
            <Box
                onClick={(event: MouseEvent<HTMLDivElement>) => {
                    event.stopPropagation();
                }}
                sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", height: "100%" }}
            >
                <TextField
                    fullWidth
                    size="small"
                    className={classes.contentFormTextField}
                    autoFocus
                    value={name}
                    onChange={(e) => handleNameChange(e.target.value)}
                    helperText={`${currentLength}/${maxLength}`}
                    inputProps={{ maxLength }}
                    FormHelperTextProps={{
                        sx: { textAlign: "right", margin: 0 },
                    }}
                />
            </Box>
        );
    }

    return (
        <div className={classes.descriptionWrapper}>
            <div className={classes.descriptionTicketNumber}>{`${t("rca.ap")}-${row.display_number}`}</div>
            <div className={classes.description}>{row.name}</div>
        </div>
    );
};

export default ActionPlanNameCell;
